// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/analytics/event.proto (package gdx.gateway.web.analytics.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * Analytics event record.
 *
 * @generated from message gdx.gateway.web.analytics.v1.Event
 */
export class Event extends Message<Event> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: repeated gdx.gateway.web.analytics.v1.Event.Params params = 5;
   */
  params: Event_Params[] = [];

  /**
   * @generated from field: gdx.gateway.web.analytics.v1.Event.Device device = 6;
   */
  device?: Event_Device;

  /**
   * If not set, backend will try to infer geo from request IP.
   *
   * @generated from field: gdx.gateway.web.analytics.v1.Event.Geo geo = 7;
   */
  geo?: Event_Geo;

  constructor(data?: PartialMessage<Event>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.analytics.v1.Event";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "params", kind: "message", T: Event_Params, repeated: true },
    { no: 6, name: "device", kind: "message", T: Event_Device },
    { no: 7, name: "geo", kind: "message", T: Event_Geo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Event {
    return new Event().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Event {
    return new Event().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Event {
    return new Event().fromJsonString(jsonString, options);
  }

  static equals(a: Event | PlainMessage<Event> | undefined, b: Event | PlainMessage<Event> | undefined): boolean {
    return proto3.util.equals(Event, a, b);
  }
}

/**
 * Describes analytics event params.
 *
 * @generated from message gdx.gateway.web.analytics.v1.Event.Params
 */
export class Event_Params extends Message<Event_Params> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  constructor(data?: PartialMessage<Event_Params>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.analytics.v1.Event.Params";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Event_Params {
    return new Event_Params().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Event_Params {
    return new Event_Params().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Event_Params {
    return new Event_Params().fromJsonString(jsonString, options);
  }

  static equals(a: Event_Params | PlainMessage<Event_Params> | undefined, b: Event_Params | PlainMessage<Event_Params> | undefined): boolean {
    return proto3.util.equals(Event_Params, a, b);
  }
}

/**
 * Describes users device.
 *
 * @generated from message gdx.gateway.web.analytics.v1.Event.Device
 */
export class Event_Device extends Message<Event_Device> {
  /**
   * @generated from field: string platform_name = 1;
   */
  platformName = "";

  /**
   * @generated from field: string platform_vendor = 2;
   */
  platformVendor = "";

  /**
   * @generated from field: string platform_model = 3;
   */
  platformModel = "";

  /**
   * @generated from field: string os_name = 4;
   */
  osName = "";

  /**
   * @generated from field: string os_version = 5;
   */
  osVersion = "";

  /**
   * @generated from field: string language = 6;
   */
  language = "";

  /**
   * @generated from field: string browser_name = 7;
   */
  browserName = "";

  /**
   * @generated from field: string browser_version = 8;
   */
  browserVersion = "";

  /**
   * @generated from field: string browser_type = 9;
   */
  browserType = "";

  constructor(data?: PartialMessage<Event_Device>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.analytics.v1.Event.Device";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "platform_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "platform_vendor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "platform_model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "os_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "os_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "browser_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "browser_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "browser_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Event_Device {
    return new Event_Device().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Event_Device {
    return new Event_Device().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Event_Device {
    return new Event_Device().fromJsonString(jsonString, options);
  }

  static equals(a: Event_Device | PlainMessage<Event_Device> | undefined, b: Event_Device | PlainMessage<Event_Device> | undefined): boolean {
    return proto3.util.equals(Event_Device, a, b);
  }
}

/**
 * Describes users geo.
 *
 * @generated from message gdx.gateway.web.analytics.v1.Event.Geo
 */
export class Event_Geo extends Message<Event_Geo> {
  /**
   * @generated from field: string city = 1;
   */
  city = "";

  /**
   * @generated from field: string country = 2;
   */
  country = "";

  /**
   * @generated from field: string state = 3;
   */
  state = "";

  constructor(data?: PartialMessage<Event_Geo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.analytics.v1.Event.Geo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Event_Geo {
    return new Event_Geo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Event_Geo {
    return new Event_Geo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Event_Geo {
    return new Event_Geo().fromJsonString(jsonString, options);
  }

  static equals(a: Event_Geo | PlainMessage<Event_Geo> | undefined, b: Event_Geo | PlainMessage<Event_Geo> | undefined): boolean {
    return proto3.util.equals(Event_Geo, a, b);
  }
}

